import Treasure from "td-js-sdk"
import * as Cookies from "td-js-sdk/lib/vendor/js-cookies"
import configurator from "../config/configurator"
import LocalData from "../utils/LocalData"

function appendPixelImage(url) {
  const img = document.createElement("img")

  img.src = (document.location.protocol === "https:" ? "https://" : "http://") + url
  img.width = 1
  img.height = 1
  img.style.display = "none"
  document.body.appendChild(img)
}

class Catalina {
  constructor(config) {
    this.config = configurator.configure(config)
    this.td = Treasure(this.config.td)
    this.td.setSignedMode(true)
    this.td.set("$global", "td_global_id", "td_global_id")
    this.clientId = Cookies.getItem("_td")
  }

  static init(config) {
    const c = new Catalina(config)
    c.addPixels()
    return c
  }

  static saveData(key, value) {
    LocalData.save(key, value)
  }

  static getData(key) {
    return LocalData.get(key)
  }

  addPixels() {
    this.td.fetchGlobalID(globalId => {
      const {
        db: { pid, psign },
        cmp: { ci, t, ua }
      } = this.config

      if (globalId) {
        // Drawbride pixel
        const dbUrl = `p.adsymptotic.com/d/px/?_pid=${pid}&_psign=${psign}&_puuid=${globalId}&_rand=${new Date().getTime()}`
        appendPixelImage(dbUrl)
      }

      if (this.clientId && ua && ci && t) {
        // CMP pixel
        const cmpUrl = `pixel.catrts.com/?v=1&ua=${ua}&did=${this.clientId}&t=${t}&ci=${ci}`
        appendPixelImage(cmpUrl)
      }
    })
  }

  // Deprecated
  writeTD(tableName, params) {
    this.track(tableName, params)
  }

  track(tableName, params) {
    const {
      td: { writeKey }
    } = this.config

    this.td.set(tableName, params)
    this.td.trackPageview(tableName, () => {
      const dbmUrl = `cm.g.doubleclick.net/pixel?google_nid=treasuredata_dmp&google_cm&td_write_key=${writeKey}&td_global_id=td_global_id`
      appendPixelImage(dbmUrl)

      const ttdUrl = `match.adsrvr.org/track/cmf/generic?ttd_pid=vbyog0i&ttd_tpi=1&account_id=8690`
      appendPixelImage(ttdUrl)
    })
  }
}

export default Catalina
